<template>
  <div class="Clientmenu" v-bind:class="menuopen === true ? 'active' : ''">
    <div class="Client-button" v-on:click="openClientMenu">
      Client: {{SelectedClient}}
      <br>
      Market:
      {{SelectedMarket}}
    </div>
    <div class="Client-selection-popup" v-if="menuopen === true">
      <div class="Clientmenu-client">
        <h6>Client</h6>
        <ul>
          <li
            v-for="market in market"
            v-on:click="SelectClient(market.name)"
            v-bind:class="SelectedClient === market.name ? 'selected' : ''"
          >{{market.name}}</li>
        </ul>
      </div>
      <div class="Clientmenu-market" v-if="clientselectedCheck">
        <h6>Market</h6>
        <ul>
          <li v-on:click="SelectMarket('All Markets')">All Markets</li>
          <li
            v-if="SelectedClient === 'All Clients'"
            v-for="SortMarket in SortMarket"
            v-on:click="SelectMarket(SortMarket)"
            v-bind:class="SelectedMarket  === SortMarket ? 'selected' : ''"
          >{{SortMarket}}</li>
          <li
            v-if="SelectedClient !== 'All Clients'"
            v-bind:class="SelectedMarket  === SelectedaMarket ? 'selected' : ''"
            v-on:click="SelectMarket(SelectedaMarket)"
            v-for="SelectedaMarket in SelectedMarketList"
          >{{SelectedaMarket}}</li>
        </ul>
      </div>
      <div class="Clientmenu-controls">
        <button
          v-on:click="CloseClientPopup"
          @keydown="CloseClientPopup"
          class="btn btn-primary btn-sm CloseClientPopup"
          tabindex="0"
        >
          Close
          <i class="fa fa-close" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
/*eslint-disable */
export default {
  name: 'Clientmenu',
  props: {
    Ddata: {
      type: Array,
    },
  },
  data: function() {
    return {
      menuopen: false,
      menudata: [],
      client: [],
      market: [],
      clientselectedCheck: false,
      SelectedClient: 'All Clients',
      SelectedMarketList: [],
      SortMarket: [],
      allMarkets: [],
      SelectedMarket: 'All Markets',
    }
  },
  methods: {
    keyHandler(e) {
      if (e.keyCode === 27) {
        this.CloseClientPopup()
      }
    },
    created() {
      window.addEventListener('keydown', e => {
        if (e.keyCode === 27) {
          this.CloseClientPopup()
        }
      })
    },
    CloseClientPopup() {
      this.menuopen = false
      this.clientselectedCheck = false
      // this.$router.go(this.$router.currentRoute)
      if (this.$router.currentRoute.path === '/') {
        this.$root.$emit('DisplayJob')
        // this.$parent.$children[2].filterfilldatatable()
        //
      } else if (this.$router.currentRoute.path === '/') {
        this.$root.$emit('DisplaySchedules')
      } else if (this.$router.currentRoute.name === 'DTStatus') {
        this.$root.$emit('FilterWeekly')
      }
    },
    openClientMenu() {
      var self = this
      this.menuopen = true
      var client = []
      var market = {}
      market[0] = {
        name: 'All Clients',
      }
      this.Ddata.forEach(function(clintnode, clintnodeindex) {
        client[clintnodeindex + 1] = clintnode.clientname.name
        market[clintnodeindex + 1] = {
          name: clintnode.clientname.name,
          market: [],
        }
        clintnode.clientname.markets.forEach(function(marketnode, marketindex) {
          market[clintnodeindex + 1].market.push(marketnode.name)
          self.allMarkets.push(marketnode.name)
        })
      })
      this.client = client
      this.market = market
      this.SortMarket = this.filterMarkets(this.allMarkets)
    },
    filterMarkets(sampleValues) {
      let uniqueValues = [...new Set(sampleValues)]
      return uniqueValues
    },
    SelectMarket(SelectedaMarket) {
      this.SelectedMarket = SelectedaMarket
      window.localStorage.setItem('client', this.SelectedClient)
      window.localStorage.setItem('market', this.SelectedMarket)
      this.CloseClientPopup()
      // this.clientselectedCheck = false
    },
    SelectClient(cl) {
      this.clientselectedCheck = true
      this.SelectedMarket = ''
      let self = this
      let clnt = cl
      this.SelectedClient = clnt
      if (this.SelectedMarket === '') {
        this.SelectedMarket = 'All Markets'
      }
      Object.keys(this.market).forEach(function(el, index) {
        if (self.market[index].name === clnt) {
          self.SelectedMarketList = self.market[index].market
          return
        }
      })
    },
  },
  mounted() {
    this.menuopen = this.Ddata
    if (window.localStorage.getItem('client') !== null) {
      this.SelectedClient = window.localStorage.getItem('client')
    } else if (window.localStorage.getItem('client') === null) {
      window.localStorage.setItem('client', 'All Clients')
    }
    if (window.localStorage.getItem('market') !== null) {
      this.SelectedMarket = window.localStorage.getItem('market')
    } else if (window.localStorage.getItem('market') === null) {
      window.localStorage.setItem('market', 'All Markets')
    }
  },
  // computed: {
  //   menudata: {
  //     set: function () {
  //       return this.Ddata
  //     },
  //     get: function () {
  //       return this.Ddata
  //     }
  //   }
  // }
}
</script>
<style lang="scss" scoped>
.Clientmenu {
  float: left;
  padding: 0px;
  transition: all 0.5s ease;
  margin: 0px auto 0px 10px;
}
.Client-button {
  display: block;
  background: #c8e687;
  height: 40px;
  width: 210px;
  box-sizing: border-box;
  margin: 5px 0 0;
  cursor: pointer;
  padding: 0px 10px;
  border: 1px solid #e4f8b8;
  text-transform: capitalize;
  font-size: 14px;
  transition: all 0.5s ease;
  position: relative;
  span {
    white-space: nowrap;
    text-transform: capitalize;
    font-size: 18px;
    position: absolute;
    top: 0px;
    .fa {
      margin: 0 5px;
    }
  }
}
.Client-selection-popup {
  display: block;
  position: absolute;
  min-width: 402px;
  max-width: 900px;
  background: #fff;
  z-index: 99999;
  border: 1px solid #ededed;
  background-color: white;
  left: 0px;
  top: 50px;
  box-shadow: 1px 1px 10px 0px rgba(0, 0, 0, 0.1);
  transition: all 0.5s ease;
}
.Clientmenu-client,
.Clientmenu-market {
  width: 200px;
  float: left;
  text-transform: capitalize;
  transition: all 0.5s ease;
  h6 {
    font-size: 18px;
    margin: 0;
    line-height: 35px;
    border: 1px solid #ededed;
    border-top: none;
    padding: 0 15px;
    box-sizing: border-box;
    border-left: none;
    color: #444;
    font-weight: 600;
    transition: all 0.5s ease;
  }
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    transition: all 0.5s ease;
    li {
      display: block;
      width: 100%;
      line-height: 35px;
      border: 1px solid #ededed;
      border-top: none;
      padding: 0 15px;
      box-sizing: border-box;
      border-left: none;
      cursor: pointer;
      background: #fff;
      transition: all 0.5s ease;
      color: #444;
      position: relative;
      &:hover,
      &.selected {
        background: #ededed;
        transition: all 0.5s ease;
        color: #444;
        font-weight: 500;
        border: 1px solid #fff;
        box-shadow: inset 1px 1px 10px 0px rgba(0, 0, 0, 0.1);
        border-top: none;
        border-left: none;
      }
      &.selected {
        &:after {
          content: '\f00c';
          display: inline-block;
          font: normal normal normal 14px/1 FontAwesome;
          font-size: inherit;
          text-rendering: auto;
          -webkit-font-smoothing: antialiased;
          position: absolute;
          right: 10px;
          line-height: 35px;
        }
      }
    }
  }
}
.Clientmenu-controls {
  float: left;
  width: 100%;
  margin-top: 20px;
  text-align: center;
  margin-bottom: 20px;
}
.Clientmenu-market {
  h6,
  ul li {
    border-left: 1px solid #ededed;
  }
}
</style>



// WEBPACK FOOTER //
// clientmenu.vue?485d8e73